import React from 'react';
import { View, Text, TouchableOpacity, Image, StyleSheet, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { motion } from 'framer-motion';
import { Ionicons, FontAwesome, Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles

const Home = () => {
  const navigation = useNavigation();

  return (
    <View style={styles.container}>


      {/* Logo at the Top */}
      <Image source={require('./assets/integrationx-logo.png')} style={styles.logo} />

      {/* Hero Content */}
      <motion.View
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Text style={styles.heading}>
          AI-Driven Automation for Seamless Integration
        </Text>
      </motion.View>

      <motion.View
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <Text style={styles.description}>
          Empowering businesses with AI-enabled integration solutions for Salesforce, Workday, and other SaaS platforms.
        </Text>
      </motion.View>

      <motion.View
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <Text style={styles.description}>
          Revolutionizing Integration with AI—Serverless, Lightweight, and Efficient.
        </Text>
      </motion.View>

      {/* CTA Button */}
      <motion.View
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 1 }}
      >
      

        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate('AboutUs')}
        >
          <Text style={styles.buttonText}>Continue Integration</Text>
        </TouchableOpacity>

      </motion.View>


    </View>
  );
};

export default Home;
